import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from '@angular/core';
import { provideRouter } from '@angular/router';

import localeEs from '@angular/common/locales/es';

import { routes } from './app.routes';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient} from "@angular/common/http";
import {AddBearerTokenInterceptor} from "./core/interceptors/add-bearer-token.interceptor";
import {NgxSpinnerModule} from "ngx-spinner";
import {provideToastr, ToastrModule} from "ngx-toastr";
import {AuthInterceptor} from "./core/interceptors/auth.interceptor";
import {provideStore, Store} from "@ngrx/store";
import {stepperReducer} from "./store/reservationForm/stepper.reducer";
import {registerLocaleData} from "@angular/common";

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore({stepper:stepperReducer}),
    provideHttpClient(),
    importProvidersFrom([BrowserAnimationsModule, HttpClientModule, NgxSpinnerModule]),
    provideToastr({
      autoDismiss: true,
      positionClass: 'toast-top-right',
      closeButton: true
    }),
    provideRouter(routes),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddBearerTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'es' },
  ],
};
registerLocaleData(localeEs, 'es');

